import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAnchor,
  faHome,
  faStore,
  faLifeRing,
  faArrowLeft,
  faCompass,
} from '@fortawesome/free-solid-svg-icons';
import '../styles/NotFoundPage.css';

/**
 * 404 Not Found Page
 * Pirate-themed error page with helpful navigation options
 */
const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const popularLinks = [
    { name: 'Home', path: '/', icon: faHome },
    { name: 'Business Listings', path: '/business-listings', icon: faStore },
    { name: 'Help & Support', path: '/support', icon: faLifeRing },
  ];

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        {/* Decorative anchor icon */}
        <div className="not-found-icon">
          <FontAwesomeIcon icon={faAnchor} />
        </div>

        {/* Error code */}
        <h1 className="not-found-code">404</h1>

        {/* Pirate-themed message */}
        <h2 className="not-found-title">Ahoy! Ye've sailed off the map!</h2>
        
        <p className="not-found-message">
          Shiver me timbers! The page ye be lookin' for has been lost to 
          Davy Jones' locker, or perhaps it never existed in these waters.
        </p>

        {/* Action buttons */}
        <div className="not-found-actions">
          <button onClick={handleGoBack} className="not-found-btn secondary">
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Go Back</span>
          </button>
          <Link to="/" className="not-found-btn primary">
            <FontAwesomeIcon icon={faCompass} />
            <span>Return to Port</span>
          </Link>
        </div>

        {/* Popular links */}
        <div className="not-found-links">
          <h3>Or navigate to:</h3>
          <ul>
            {popularLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>
                  <FontAwesomeIcon icon={link.icon} />
                  <span>{link.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Decorative wave background */}
      <div className="not-found-waves">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="rgba(59, 130, 246, 0.1)"
            d="M0,192L48,181.3C96,171,192,149,288,154.7C384,160,480,192,576,197.3C672,203,768,181,864,181.3C960,181,1056,203,1152,197.3C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
          <path
            fill="rgba(59, 130, 246, 0.15)"
            d="M0,256L48,261.3C96,267,192,277,288,261.3C384,245,480,203,576,186.7C672,171,768,181,864,197.3C960,213,1056,235,1152,224C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default NotFoundPage;
